import { ChangeEvent, FormEvent, useState } from 'react';

const usePhoenixForm = defaultValues => {
  const [formData, setFormData] = useState(defaultValues || {});

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: ['checkbox', 'radio'].includes(e.target.type)
        ? e.target.checked
        : e.target.value
    });
  };

  const setValue = values => {
    setFormData({
      ...formData,
      ...values
    });
  };

  const onSubmit = e => {
    e.preventDefault();
    console.log({ formData });
  };
  return { formData, setFormData, setValue, onChange, onSubmit };
};

export default usePhoenixForm;
